import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import DateInputField from "../../components/forms/DateInputField";
import ValueField from "../../components/forms/ValueField";
import FormError from "../../components/forms/FormError";
import Loading from "../../components/Loading";
import format from "date-fns/format";

class ScheduleShipmentForm extends Component {

  render() {
    let {errors, handleSubmit, submit, submitting, showDatePicker, showDatesAreRecommended, message} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    let recommendedDatesInfo = null;
    if (showDatesAreRecommended) {
      recommendedDatesInfo = <ValueField label="" value="Dates recommended for warehouse" />
    }
    let info = null;
    if (message.length > 0) {
      info = <p>{message}</p>
    }
    let deliveryDateField = null;
    if (this.props.showDeliveryDate) {
      deliveryDateField = <ValueField label="Delivery Date" value={format(this.props.deliveryDate, "ddd D MMM, YYYY")} />
    }
    let loadingDeliveryDate = null;
    if (this.props.loadingDeliveryDate) {
      loadingDeliveryDate = <Loading />
    }
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          {info}
          <FormFieldsTable>
            <Field 
              label="Prep Date"
              name="prepDate"
              component={DateInputField}
              showDatePicker={showDatePicker}
              dateFormat="ddd D MMM, YYYY"
              serverError={this.props.errors.prepDate}
              />
            <Field 
              label="Pickup Date"
              name="pickupDate"
              component={DateInputField}
              showDatePicker={showDatePicker}
              dateFormat="ddd D MMM, YYYY"
              serverError={this.props.errors.pickupDate}
              />
            {loadingDeliveryDate}
            {deliveryDateField}
            {recommendedDatesInfo}
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
          <ActionButton label="Set Delivery Date" active={!submitting} onClick={this.props.onUseCalendar} />
          <ActionButton label="Auto Set Dates" active={!showDatesAreRecommended} onClick={this.props.onAutoSetDates} />
        </div>
      </form>
    )
  }
}

ScheduleShipmentForm.defaultProps = {
  showDeliveryDate: false
}

const ReduxForm = reduxForm({
  form: "ScheduleShipmentForm"
})(ScheduleShipmentForm);

export default ReduxForm;